(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabaid-editorial-article"] && !Shopify.designMode) return;
  try {
    
  const initCabaidRoutineFinders = () => {
    document.querySelectorAll('[data-cabaid-routine-finder]').forEach((finder) => {
      if (finder.dataset.cabaidInitialized === 'true') return;
      finder.dataset.cabaidInitialized = 'true';

      const form = finder.querySelector('form');
      const error = finder.querySelector('.cabaid-finder-error');
      const result = finder.querySelector('.cabaid-finder-result');
      const title = finder.querySelector('[data-result-title]');
      const copy = finder.querySelector('[data-result-copy]');
      const actions = finder.querySelector('[data-result-actions]');

      if (!form || !error || !result || !title || !copy || !actions) return;

      const link = (label, href, primary = false) => {
        const anchor = document.createElement('a');
        anchor.className = `cabaid-button ${primary ? 'cabaid-button-primary' : 'cabaid-button-outline-light'}`;
        anchor.href = href;
        anchor.textContent = label;
        return anchor;
      };

      const show = (heading, message, links) => {
        title.textContent = heading;
        copy.textContent = message;
        actions.replaceChildren(...links);
        result.hidden = false;
        error.hidden = true;
        result.focus();
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const values = Object.fromEntries(new FormData(form).entries());
        const complete = ['skin', 'goal', 'marks', 'routine'].every((key) => values[key]);

        if (!complete) {
          error.hidden = false;
          result.hidden = true;
          return;
        }

        if (values.skin !== 'closed') {
          show(
            'Pause cosmetic topical care for now.',
            'Open, draining, infected, or uncertain skin needs medical guidance—not a product recommendation. Wait until the area is fully closed and a healthcare professional has approved topical care.',
            [link('Read the fully-healed skin guidance', '#fully-healed-guidance')]
          );
          return;
        }

        if (values.goal === 'dramatic') {
          show(
            'A dermatologist may match your goal better.',
            'Creams can support moisture, softness, and modest appearance changes, but they are unlikely to produce removal or procedure-level results. A qualified dermatologist can discuss options, tradeoffs, skin-tone considerations, cost, and downtime.',
            [link('Read when a dermatologist may help', '#when-a-dermatologist-may-be-the-better-next-step'), link('See the honest topical option', '#where-cabaid-fits')]
          );
          return;
        }

        if (values.routine === 'irregular') {
          show(
            'Choose a comfort-first routine you can repeat.',
            'Occasional use may improve skin feel in the moment, but it is difficult to judge appearance support without consistency. Start with moisture and comfort; only commit to a longer trial if the routine fits your real life.',
            [link('See the 8–12 week plan', '#how-long-does-stretch-mark-cream-take-to-work'), link('Review the CABAID formula', '#where-cabaid-fits', true)]
          );
          return;
        }

        if (values.marks === 'mature') {
          show(
            'A realistic mature-mark routine may fit.',
            'Older white or silver marks generally respond less to topical care than newer colored marks. A cream can still support hydration, softness, and smoother-looking skin; treat any visible change as a possibility, not a promise.',
            [link('See the 8–12 week plan', '#how-long-does-stretch-mark-cream-take-to-work'), link('Review the CABAID formula', '#where-cabaid-fits', true)]
          );
          return;
        }

        if (values.goal === 'comfort') {
          show(
            'A comfort-and-skin-feel routine is a strong match.',
            'Moisture, softness, and less tight-feeling skin are the most dependable benefits of a well-formulated body cream. Track those benefits first instead of judging the routine only by whether a mark fades.',
            [link('See the routine steps', '#a-realistic-stretch-mark-cream-routine'), link('Review the CABAID formula', '#where-cabaid-fits', true)]
          );
          return;
        }

        show(
          'A consistent appearance-care routine may fit.',
          'Your goal is aligned with what topical care can honestly attempt: moisturized, softer-feeling, smoother-looking skin and the possibility of modest appearance support. Use the same conditions to evaluate progress over 8–12 weeks.',
          [link('See the 8–12 week plan', '#how-long-does-stretch-mark-cream-take-to-work'), link('Shop Stretch Mark Cream', '/products/stretch-mark-scar-appearance-cream', true)]
        );
      });

      form.addEventListener('reset', () => {
        window.setTimeout(() => {
          error.hidden = true;
          result.hidden = true;
          title.textContent = '';
          copy.textContent = '';
          actions.replaceChildren();
        }, 0);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCabaidRoutineFinders, { once: true });
  } else {
    initCabaidRoutineFinders();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
